import { Outlet } from "react-router-dom";
import {
    Box,
    CssBaseline
    // AppBar as MuiAppBar,
    // AppBarProps as MuiAppBarProps,
    // styled,
    // useTheme,
    // Toolbar,
    // IconButton,
    // Drawer,
    // Grid,
    // Typography
} from "@mui/material";

// import satiLogo from "assets/SatiLogo.svg";

// import { Menu as MenuIcon } from "@mui/icons-material";
// import useDrawer from "hooks/useDrawer";

// const drawerWidth = 240;

// const AppBar = styled(MuiAppBar, {
//     shouldForwardProp: (prop) => prop !== "open"
// })<AppBarProps>(({ theme, open }) => ({
//     transition: theme.transitions.create(["margin", "width"], {
//         easing: theme.transitions.easing.sharp,
//         duration: theme.transitions.duration.leavingScreen
//     }),
//     ...(open && {
//         marginLeft: `${drawerWidth}px`,
//         transition: theme.transitions.create(["margin", "width"], {
//             easing: theme.transitions.easing.easeOut,
//             duration: theme.transitions.duration.enteringScreen
//         })
//     })
// }));

// const DrawerHeader = styled("div")(({ theme }) => ({
//     display: "flex",
//     alignItems: "center",
//     padding: theme.spacing(0, 1),
//     // necessary for content to be below app bar
//     ...theme.mixins.toolbar,
//     justifyContent: "flex-end"
// }));

// interface AppBarProps extends MuiAppBarProps {
//     open?: boolean;
// }

export default function Layout() {
    // const { handleDrawerOpen, handleDrawerClose, drawerOpen } = useDrawer();

    // const theme = useTheme();

    return (
        <Box sx={{ display: "flex", width: "100%", height: "100vh" }}>
            <CssBaseline />

            {/* <AppBar elevation={0} position="fixed" open={drawerOpen}>
                <Toolbar
                    sx={{
                        backgroundColor: (theme) =>
                            theme.palette.secondary.main,
                        display: "flex"
                    }}
                >
                    <Box
                        display="flex"
                        width="100%"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Box>
                            <IconButton
                                aria-label="open drawer"
                                onClick={
                                    drawerOpen
                                        ? handleDrawerClose
                                        : handleDrawerOpen
                                }
                                edge="start"
                                sx={{
                                    mr: 2,
                                    color: (theme) => theme.palette.common.white
                                }}
                            >
                                <MenuIcon />
                            </IconButton>
                        </Box>
                        <Box display="flex" alignItems="center">
                            <Typography
                                noWrap
                                sx={{
                                    color: (theme) => theme.palette.common.white
                                }}
                            >
                                DX Interception By
                            </Typography>
                            <img
                                style={{ width: 12, marginLeft: 12 }}
                                alt="logo"
                                src={satiLogo}
                            />
                        </Box>
                    </Box>
                </Toolbar>
            </AppBar>
            <Drawer
                sx={{
                    width: drawerOpen ? drawerWidth : 0,
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: drawerWidth,
                        boxSizing: "border-box",
                        backgroundImage:
                            "linear-gradient(178.24deg, #06314D 47.86%, #44EDC7 218.29%)"
                    }
                }}
                onClose={handleDrawerClose}
                anchor="left"
                open={drawerOpen}
            >
                <DrawerHeader>
                    <Box
                        position="relative"
                        width="100%"
                        display={"flex"}
                        justifyContent="center"
                        height={120}
                    >
                        <Box
                            width={drawerWidth}
                            p={2}
                            display="flex"
                            justifyContent={"center"}
                        >
                            <img
                                style={{ width: 60, cursor: "pointer" }}
                                alt="logo"
                                src={satiLogo}
                            />
                        </Box>
                    </Box>
                </DrawerHeader>
                <Grid
                    height={"100%"}
                    container
                    alignItems="space-betweens"
                    justifyContent="space-between"
                    flexDirection="column"
                >
                    <Grid item container>
                        <Grid container item justifyContent="center" p={1}>
                            <Typography
                                variant="h1"
                                sx={() => ({
                                    fontSize: 14,
                                    textAlign: "center",
                                    fontWeight: 600
                                })}
                                color="white"
                                mb={1}
                            >
                                “
                                <span
                                    style={{
                                        color: theme.palette.primary.main
                                    }}
                                >
                                    AI-Powered
                                </span>{" "}
                                Automatic Coding <br />& Decision Support
                                System”
                            </Typography>
                        </Grid>
                        <Grid item container></Grid>
                    </Grid>
                </Grid>
            </Drawer> */}
            <Box
                sx={{
                    backgroundColor: (theme) =>
                        theme.palette.greyBackground.main,
                    width: "100%",
                    padding: 2
                }}
            >
                {/* <DrawerHeader /> */}
                <Outlet />
            </Box>
        </Box>
    );
}
